import React from "react";
import ReactGA from "react-ga4";

// assets
import AdBannerLogo from "bodycodi/cmap/app/img/ad-banner.png";

const AdBanner = () => {
  const EVENT_ON = new Date("2024-03-08T00:00:00").getTime();
  const EVENT_OFF = new Date("2024-04-19T00:00:00").getTime();
  const currentDate = new Date().getTime();

  const isEventTime = currentDate > EVENT_ON && currentDate < EVENT_OFF;

  const link = "https://crm-guide.bodycodi.com/fec93184-d4ea-4c8b-9d2a-58ab1e776dbd";

  const handleClick = (targetUrl: string) => {
    ReactGA.event({
      category: "Banners",
      action: "banner_click",
      label: "Banner clicked",
      value: 1,
    });

    if (window.ReactNativeWebView) {
      const data = JSON.stringify({
        type: "openExternalLink",
        link: targetUrl,
      });
      window.ReactNativeWebView.postMessage(data);
    } else {
      window.location.href = targetUrl;
    }
  };

  if (!isEventTime) return null;

  return (
    <div className="ad-banner">
      <div className="card" onClick={() => handleClick(link)}>
        <div>
          <span>[마감임박] 운동인 전용보험 무료</span>
          <span>보험금 무료! 바디코디가 100% 보장</span>
        </div>

        <img src={AdBannerLogo} alt="ad_banner_img" />
      </div>
    </div>
  );
};

export default AdBanner;
